import {
  PLAN_GET, PLAN_GET_SUCCESS, PLAN_GET_FAILURE,
  PLAN_SAVE, PLAN_SAVE_SUCCESS, PLAN_SAVE_FAILURE,
  PLAN_SEARCH, PLAN_SEARCH_SUCCESS, PLAN_SEARCH_FAILURE,
  PLAN_EXIST_NEXT_MONTH, PLAN_EXIST_NEXT_MONTH_SUCCESS, PLAN_EXIST_NEXT_MONTH_FAILURE,
  PLAN_SAVE_NEXT_MONTH, PLAN_SAVE_NEXT_MONTH_SUCCESS, PLAN_SAVE_NEXT_MONTH_FAILURE,
  PLAN_SET_ENABLE_PATIENT, PLAN_SET_ENABLE_PATIENT_SUCCESS, PLAN_SET_ENABLE_PATIENT_FAILURE,
  PLAN_REMOVE, PLAN_REMOVE_SUCCESS, PLAN_REMOVE_FAILURE,
  PLAN_PDF, PLAN_PDF_SUCCESS, PLAN_PDF_FAILURE,
  PLAN_REMOVE_PDF, PLAN_REMOVE_PDF_SUCCESS, PLAN_REMOVE_PDF_FAILURE,
  PLAN_CLEAR, PLAN_MSG_ALERT,
  PLAN_LIST_SEARCH, PLAN_LIST_SEARCH_SUCCESS, PLAN_LIST_SEARCH_FAILURE, PLAN_LIST_SEARCH_CLEAR,
  PLAN_NEXT_MONTH_CHECK, PLAN_NEXT_MONTH_CHECK_FAILURE, PLAN_NEXT_MONTH_CHECK_SUCCESS,
  PLAN_EDIT_NEXT_MONTH, PLAN_EDIT_NEXT_MONTH_SUCCESS, PLAN_EDIT_NEXT_MONTH_FAILURE,
  PLAN_COPY_EDIT, PLAN_COPY_EDIT_SUCCESS, PLAN_COPY_EDIT_FAILURE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    plans: [],
    plansNextPage: 1,
    plansList: null,
    plansListNextPage: null,
    plansListTotalCount: 0,
    plansListNextPageLink: null,
    plansListCurrentPage: null,
    plansListExists: true,
    plansListParams: null,
    notify: ''
  },

  getters: {
    planNotify: state => {
      return state.notify
    },
    plans: state => {
      return state.plans
    },
    plansNextPage: state => {
      return state.plansNextPage
    },
    plansList: state => {
      return state.plansList
    },
    plansListNextPage: state => {
      return state.plansListNextPage
    },
    plansListTotalCount: state => {
      return state.plansListTotalCount
    },
    plansListNextPageLink: state => {
      return state.plansListNextPageLink
    },
    plansListCurrentPage: state => {
      return state.plansListCurrentPage
    },
    plansListParams: state => {
      return state.plansListParams
    }
  },

  actions: {
    [PLAN_GET] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = true
      if (params) {
        data = params.data
        if (params.loadparams) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiGet', {url: '/plans/get', data: data, loadparams: loadparams})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_GET_FAILURE, res.data)
            } else {
              commit(PLAN_GET_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [PLAN_SAVE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/plans/save', data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_SAVE_FAILURE, res.data)
            } else {
              commit(PLAN_SAVE_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },

    [PLAN_COPY_EDIT] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/plans/copy_edit', data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_COPY_EDIT_FAILURE, res.data)
            } else {
              commit(PLAN_COPY_EDIT_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },

    [PLAN_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/plans/select_plans', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_SEARCH_FAILURE, res.data)
            } else {
              commit(PLAN_SEARCH_SUCCESS, res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
    },

    [PLAN_EXIST_NEXT_MONTH] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: '/plans/exist_next_month', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_EXIST_NEXT_MONTH_FAILURE, res.data)
            } else {
              commit(PLAN_EXIST_NEXT_MONTH_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },

    [PLAN_SAVE_NEXT_MONTH] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/plans/save_next_month', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_SAVE_NEXT_MONTH_FAILURE, res.data)
            } else {
              commit(PLAN_SAVE_NEXT_MONTH_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [PLAN_NEXT_MONTH_CHECK] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/plans/next_month_check', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_NEXT_MONTH_CHECK_FAILURE, res.data)
            } else {
              commit(PLAN_NEXT_MONTH_CHECK_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [PLAN_EDIT_NEXT_MONTH] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPost', {url: '/plans/edit_next_month', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_EDIT_NEXT_MONTH_FAILURE, res.data)
            } else {
              commit(PLAN_EDIT_NEXT_MONTH_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [PLAN_SET_ENABLE_PATIENT] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/plans/set_enable_patient', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_SET_ENABLE_PATIENT_FAILURE, res.data)
            } else {
              commit(PLAN_SET_ENABLE_PATIENT_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },

    [PLAN_REMOVE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiDelete', {url: '/plans/remove', data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_REMOVE_FAILURE, res.data)
            } else {
              commit(PLAN_REMOVE_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },

    [PLAN_PDF] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = true
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiGet', {url: '/plans/pdf', data: data, loadparams: loadparams})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PLAN_PDF_FAILURE, res.data)
            } else {
              commit(PLAN_PDF_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },

    [PLAN_REMOVE_PDF] ({dispatch, state, commit}, params) {
      var data = {}
      var loadparams = false
      if (params) {
        data = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      setTimeout(() => {
        dispatch('apiDelete', {url: '/plans/remove_pdf', data: data, loadparams: loadparams})
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(PLAN_REMOVE_PDF_FAILURE, res.data)
              } else {
                commit(PLAN_REMOVE_PDF_SUCCESS, {
                  data: res.data,
                  callback: params.callback
                })
              }
            }
          })
          .catch(error => {
            throw error
          })
      }, 5000)
    },

    [PLAN_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(PLAN_CLEAR)
      }, sleep)
    },

    /** 計画書検索 */
    [PLAN_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/plans'
      var loadparams = true
      var callback = () => {}
      state.plansListExists = true
      if (params) {
        data = params.data
        state.plansListParams = params.data
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if (params.url) {
          url = params.url
        }
        if (params.clear) {
          state.plansList = null
          state.plansListNextPage = null
          state.plansListTotalCount = 0
          state.plansListNextPageLink = null
          state.plansListCurrentPage = null
        }
        if (params.callback) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PLAN_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(PLAN_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PLAN_MSG_ALERT] ({state, commit}, msg) {
      commit(PLAN_MSG_ALERT, msg)
    },
    [PLAN_LIST_SEARCH_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(PLAN_LIST_SEARCH_CLEAR)
      }, sleep)
    }
  },

  mutations: {
    [PLAN_GET_FAILURE] (state, data) {
      console.log('PLAN_GET_FAILURE')
      state.notify = {message_i18n: 'messages.search.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_GET_SUCCESS] (state, data) {
      console.log('PLAN_GET_SUCCESS')
      data.callback(data.data[Object.keys(data.data)[0]])
    },
    [PLAN_SAVE_FAILURE] (state, data) {
      console.log('PLAN_SAVE_FAILURE')
      state.notify = {message_i18n: 'messages.save.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_SAVE_SUCCESS] (state, data) {
      console.log('PLAN_SAVE_SUCCESS')
      state.notify = {message_i18n: 'plan.plan_save_success_message', success: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
      data.callback(data.data[Object.keys(data.data)[0]])
    },
    [PLAN_COPY_EDIT_FAILURE] (state, data) {
      console.log('PLAN_COPY_EDIT_FAILURE')
      state.notify = {message_i18n: 'plan.copy_edit_filure_message', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_COPY_EDIT_SUCCESS] (state, data) {
      console.log('PLAN_COPY_EDIT_SUCCESS')
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
      data.callback(data.data)
    },
    [PLAN_SEARCH_FAILURE] (state, data) {
      console.log('PLAN_SEARCH_FAILURE')
      state.notify = {message_i18n: 'messages.search.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_SEARCH_SUCCESS] (state, data) {
      console.log('PLAN_SEARCH_SUCCESS')
      state.plans = data.data
      if (data.meta && data.meta['next-page']) {
        state.plansNextPage = data.meta['next-page']
      }
    },
    [PLAN_EXIST_NEXT_MONTH_FAILURE] (state, data) {
      console.log('PLAN_EXIST_NEXT_MONTH_FAILURE')
      state.notify = {message_i18n: 'messages.search.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_EXIST_NEXT_MONTH_SUCCESS] (state, data) {
      console.log('PLAN_EXIST_NEXT_MONTH_SUCCESS')
      data.callback(data.data)
    },
    [PLAN_SAVE_NEXT_MONTH_FAILURE] (state, data) {
      console.log('PLAN_SAVE_NEXT_MONTH_FAILURE')
      state.notify = {message_i18n: 'plan.save_failure_message', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_SAVE_NEXT_MONTH_SUCCESS] (state, data) {
      console.log('PLAN_SAVE_NEXT_MONTH_SUCCESS')
      state.notify = {message_i18n: 'plan.save_success_message', success: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
      data.callback(data.data)
    },
    [PLAN_NEXT_MONTH_CHECK_FAILURE] (state, data) {
      console.log('PLAN_NEXT_MONTH_CHECK_FAILURE')
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_NEXT_MONTH_CHECK_SUCCESS] (state, data) {
      console.log('PLAN_NEXT_MONTH_CHECK_SUCCESS')
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
      data.callback(data.data)
    },
    [PLAN_EDIT_NEXT_MONTH_FAILURE] (state, data) {
      console.log('PLAN_EDIT_NEXT_MONTH_FAILURE')
      state.notify = {message_i18n: 'plan.edit_next_month_success_message', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_EDIT_NEXT_MONTH_SUCCESS] (state, data) {
      console.log('PLAN_EDIT_NEXT_MONTH_SUCCESS')
      state.notify = {message_i18n: 'plan.edit_next_month_success_message', success: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
      data.callback(data.data[Object.keys(data.data)[0]])
    },
    [PLAN_SET_ENABLE_PATIENT_FAILURE] (state, data) {
      console.log('PLAN_SET_ENABLE_PATIENT_FAILURE')
      state.notify = {message_i18n: 'messages.search.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_SET_ENABLE_PATIENT_SUCCESS] (state, data) {
      console.log('PLAN_SET_ENABLE_PATIENT_SUCCESS')
      if (data.data.enable_flag) {
        state.notify = {message_i18n: 'plan.set_enable_success_message', success: true}
      } else {
        state.notify = {message_i18n: 'plan.set_disable_success_message', success: true}
      }
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
      data.callback(data.data)
    },
    [PLAN_REMOVE_FAILURE] (state, data) {
      console.log('PLAN_REMOVE_FAILURE')
      state.notify = {message_i18n: 'messages.delete.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_REMOVE_SUCCESS] (state, data) {
      console.log('PLAN_REMOVE_SUCCESS')
      state.notify = {message_i18n: 'plan.remove_success_message', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
      data.callback(data.data)
    },
    [PLAN_PDF_FAILURE] (state, data) {
      console.log('PLAN_PDF_FAILURE')
      state.notify = {message_i18n: 'messages.pdf.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_PDF_SUCCESS] (state, data) {
      console.log('PLAN_PDF_SUCCESS')
      data.callback(data.data)
    },
    [PLAN_REMOVE_PDF_FAILURE] (state, data) {
      console.log('PLAN_REMOVE_PDF_FAILURE')
      state.notify = {message_i18n: 'messages.delete.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_REMOVE_PDF_SUCCESS] (state, data) {
      console.log('PLAN_REMOVE_PDF_SUCCESS')
      data.callback(data.data)
    },
    [PLAN_CLEAR] (state) {
      state.plans = []
    },
    [PLAN_LIST_SEARCH_FAILURE] (state, data) {
      console.log('PLAN_LIST_SEARCH_FAILURE')
      state.plansListExists = false
      state.notify = {message_i18n: 'messages.search.danger', danger: true}
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    },
    [PLAN_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('PLAN_LIST_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      state.plansListTotalCount = 0

      if (data.meta) {
        if (data.meta['re-search']) {
          reSearch = data.meta['re-search']
        }

        if (reSearch) {
          // 再検索
          state.plansList = data.data
          if (data.meta['next-page'] === null) {
            // 次へのリンクが無かったら
            state.plansListNextPage = null
          }
        } else {
          if (data.meta['current-page'] && data.meta['current-page'] > 1) {
            state.plansList = state.plansList.concat(data.data)
            state.plansListCurrentPage = data.meta['current-page']
          } else {
            state.plansList = data.data
            state.plansListCurrentPage = data.meta['current-page']
          }
          state.plansListNextPage = null
          if (data.meta['next-page']) {
            state.plansListNextPage = data.meta['next-page']
          }
        }
        if (data.meta['total-count']) {
          state.plansListTotalCount = data.meta['total-count']
        }
        if (data.links && data.links['next']) {
          state.plansListNextPageLink = data.links['next']
        } else {
          state.plansListNextPageLink = null
        }
      } else {
        state.plansList = data.data
      }

      if (state.plansListTotalCount > 0) {
        state.plansListExists = true  // データあり
      } else {
        state.plansListExists = false // データなし
      }
      if (params.callback) {
        params.callback()
      }
    },
    /** メッセージ表示用 */
    [PLAN_MSG_ALERT] (state, msg) {
      console.log('PLAN_MSG_ALERT')
      state.notify = msg
      setTimeout(() => { state.notify = null }, constant.notifyShowTime.normal)
    },
    [PLAN_LIST_SEARCH_CLEAR] (state) {
      state.plansList = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/plan.js